import { useCallback } from "react";

import { useDialogsProvider } from "2g-dialogs-provider";
import ZpracDialog from "2g-zprac-dialog";

import { FILES } from "b2b/api";

import useMessages from "../i18n/useMessages";

export default function useDelete() {
  const { deleteDialogTitle, deleteDialogConfrimMesage } = useMessages();
  const { showDialog, hideDialog } = useDialogsProvider();

  const handleSuccess = useCallback(
    onSuccess => {
      hideDialog();
      onSuccess();
    },
    [hideDialog]
  );

  return useCallback(
    (file, onSuccess) => {
      showDialog(ZpracDialog, {
        url: FILES.provozniInformace(file.key),
        method: "delete",
        title: deleteDialogTitle(),
        confirmMessage: deleteDialogConfrimMesage({ name: file.name }),
        onSuccess: () => handleSuccess(onSuccess),
        onClose: hideDialog
      });
    },
    [
      showDialog,
      hideDialog,
      deleteDialogTitle,
      deleteDialogConfrimMesage,
      handleSuccess
    ]
  );
}
